import { FC, HTMLAttributes } from 'react';
import { useTranslation } from 'react-i18next';

import { Button, Flex } from 'antd';

import LandingIcon from 'assets/images/onboarding/landing.svg?react';
import { useOnboardingSlice } from 'features/Onboarding';
import { EOnboardingStates } from 'features/Onboarding/model/types';
import { EYmEvents, EYmEventsO1, EYmEventsO2 } from 'shared/typings';
import { sendYmEvent } from 'shared/utils';

import { OnboardingText } from '../OnboardingText/OnboardingText';

interface IWelcomeProps extends HTMLAttributes<HTMLDivElement> {}

export const Welcome: FC<IWelcomeProps> = ({ ...props }) => {
	const { t } = useTranslation();
	const { setModalState } = useOnboardingSlice();

	const handleLetsBeginClick = () => {
		setModalState(EOnboardingStates.STEPS);
		sendYmEvent({
			event: EYmEvents.CLICK_START,
			o1: [EYmEventsO1.ACCOUNT, EYmEventsO1.PUBLISHER, EYmEventsO1.WELCOME_POPUP],
			o2: EYmEventsO2.WELCOME,
		});
	};

	return (
		<Flex {...props} vertical align="center" gap={24}>
			<LandingIcon />
			<OnboardingText
				header={t('Добро пожаловать в Affilead!')}
				text={t(
					`Давайте начнем ваше путешествие с простого процесса адаптации. Мы поможем вам создать свою первую площадку и ознакомиться с офферами.`,
				)}
			/>
			<Flex justify="center">
				<Button onClick={handleLetsBeginClick} type="primary">
					{t(`Давайте начнем`)}
				</Button>
			</Flex>
		</Flex>
	);
};
